<input class="formatted-amount" [formControl]="control" [style.textAlign]="textAlign" />
